import styled from 'styled-components';
import { rem } from 'polished';

const StyledWrapperWithholding = styled.div`
  margin-top: ${rem('37px')};
`;

const StyledModalContent = styled.div`
  display: flex;
  justify-content: center;
`;
export { StyledWrapperWithholding, StyledModalContent };
